function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/fontbackgroundcolor/fontbackgroundcolorediting
 */
import { Plugin } from 'ckeditor5/src/core';
import { addBackgroundRules } from 'ckeditor5/src/engine';
import FontBackgroundColorCommand from './fontbackgroundcolorcommand';
import { FONT_BACKGROUND_COLOR, renderDowncastElement, renderUpcastAttribute } from '../utils';
/**
 * The font background color editing feature.
 *
 * It introduces the {@link module:font/fontbackgroundcolor/fontbackgroundcolorcommand~FontBackgroundColorCommand command} and
 * the `fontBackgroundColor` attribute in the {@link module:engine/model/model~Model model} which renders
 * in the {@link module:engine/view/view view} as a `<span>` element (`<span style="background-color: ...">`),
 * depending on the {@link module:font/fontbackgroundcolor~FontBackgroundColorConfig configuration}.
 *
 * @extends module:core/plugin~Plugin
 */

var FontBackgroundColorEditing =
/*#__PURE__*/
function (_Plugin) {
  _inherits(FontBackgroundColorEditing, _Plugin);

  _createClass(FontBackgroundColorEditing, null, [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'FontBackgroundColorEditing';
    }
    /**
     * @inheritDoc
     */

  }]);

  function FontBackgroundColorEditing(editor) {
    var _this;

    _classCallCheck(this, FontBackgroundColorEditing);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FontBackgroundColorEditing).call(this, editor));
    editor.config.define(FONT_BACKGROUND_COLOR, {
      colors: [{
        color: 'hsl(0, 0%, 0%)',
        label: 'Black'
      }, {
        color: 'hsl(0, 0%, 30%)',
        label: 'Dim grey'
      }, {
        color: 'hsl(0, 0%, 60%)',
        label: 'Grey'
      }, {
        color: 'hsl(0, 0%, 90%)',
        label: 'Light grey'
      }, {
        color: 'hsl(0, 0%, 100%)',
        label: 'White',
        hasBorder: true
      }, {
        color: 'hsl(0, 75%, 60%)',
        label: 'Red'
      }, {
        color: 'hsl(30, 75%, 60%)',
        label: 'Orange'
      }, {
        color: 'hsl(60, 75%, 60%)',
        label: 'Yellow'
      }, {
        color: 'hsl(90, 75%, 60%)',
        label: 'Light green'
      }, {
        color: 'hsl(120, 75%, 60%)',
        label: 'Green'
      }, {
        color: 'hsl(150, 75%, 60%)',
        label: 'Aquamarine'
      }, {
        color: 'hsl(180, 75%, 60%)',
        label: 'Turquoise'
      }, {
        color: 'hsl(210, 75%, 60%)',
        label: 'Light blue'
      }, {
        color: 'hsl(240, 75%, 60%)',
        label: 'Blue'
      }, {
        color: 'hsl(270, 75%, 60%)',
        label: 'Purple'
      }],
      columns: 5
    });
    editor.data.addStyleProcessorRules(addBackgroundRules);
    editor.conversion["for"]('upcast').elementToAttribute({
      view: {
        name: 'span',
        styles: {
          'background-color': /[\s\S]+/
        }
      },
      model: {
        key: FONT_BACKGROUND_COLOR,
        value: renderUpcastAttribute('background-color')
      }
    });
    editor.conversion["for"]('downcast').attributeToElement({
      model: FONT_BACKGROUND_COLOR,
      view: renderDowncastElement('background-color')
    });
    editor.commands.add(FONT_BACKGROUND_COLOR, new FontBackgroundColorCommand(editor)); // Allow the font backgroundColor attribute on text nodes.

    editor.model.schema.extend('$text', {
      allowAttributes: FONT_BACKGROUND_COLOR
    });
    editor.model.schema.setAttributeProperties(FONT_BACKGROUND_COLOR, {
      isFormatting: true,
      copyOnEnter: true
    });
    return _this;
  }

  return FontBackgroundColorEditing;
}(Plugin);

export { FontBackgroundColorEditing as default };